import { AnyAction } from 'redux';
import {
  App,
  BasisAdresse,
  Immobilie,
  PlzChanged,
  RsVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { RsActions } from '../rsActions';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      const immobilie: Immobilie = action.payload.immobilie as Immobilie;

      if (!immobilie || action.payload.appId !== App.RS) {
        return sectionState;
      }

      const risikoort: BasisAdresse = immobilie.risikoort;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case RsActions.PLZ_CHANGED: {
      const actionPayload: PlzChanged = action.payload;
      return {
        plz: actionPayload.plz,
        strasse: '',
        hausnummer: '',
        ort: '',
      };
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.RS_BASISDATEN) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        return {
          ...sectionState,
          ort: action.payload.orte[0],
        };
      }
      return sectionState;
    }
    case RsActions.ORT_CHANGED: {
      return { ...sectionState, ort: action.payload.ort };
    }
    case RsActions.STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload.strasse };
    }
    case RsActions.HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload.hausnummer };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const risikoort: BasisAdresse = action.payload.versicherungsnehmer.adresse;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS) {
        return {
          ...sectionState,
          plz: actionPayload.vnAdresse?.plz,
          strasse: actionPayload.vnAdresse?.strasse,
          hausnummer: actionPayload.vnAdresse?.hausnummer,
          ort: actionPayload.vnAdresse?.ort,
        };
      }
      return sectionState;
    }

    default:
      return sectionState;
  }
};
